import React from 'react';

export function useAbortController() {
  const [abortController, setAbortController] = React.useState(() => {
    return new AbortController();
  });

  const setupAbortController = React.useCallback(() => {
    const abortController = new AbortController();
    setAbortController(abortController);

    return abortController.signal;
  }, []);

  return {
    abortController,
    setupAbortController,
  };
}
